import { Title, Flex, Button, ScrollArea } from '@mantine/core';
import { modals } from '@mantine/modals';

import {
  useGetPaymentMethods,
  PaymentMethodsTable,
  CreatePaymentMethodsForm,
} from '@/modules/payment-methods';

export const PaymentMethods = () => {
  const {
    data,
    isLoading,
  } = useGetPaymentMethods();

  const openCreateModal = () => modals.open({
    title: 'Добавление платёжного метода',
    // centered: true,
    scrollAreaComponent: ScrollArea.Autosize,
    children: (
      <CreatePaymentMethodsForm
        onClose={modals.closeAll}
      />
    ),
  });

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Платёжные методы</Title>

        <Button
          variant="filled"
          onClick={openCreateModal}
        >
          Создать
        </Button>
      </Flex>

      <PaymentMethodsTable
        items={data || []}
        isLoading={isLoading}
      />
    </>
  );
};
